import { Box, Button } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";

interface HeaderGoBackProps {
  /**
   * @default "default"
   * @description Controls the size of header components
   * - default: normal size
   * - narrow: compact size
   */
  size?: "default" | "narrow";
}

export const HeaderGoBack = ({ size = "default" }: HeaderGoBackProps) => {
  const navigate = useNavigate();
  const isNarrow = size === "narrow";

  return (
    <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
      <Button
        onClick={() => navigate(-1)}
        startIcon={<ArrowBack fontSize={isNarrow ? "small" : "medium"} />}
        sx={{
          color: "text.primary",
          alignSelf: "center",
          padding: isNarrow ? "4px 8px" : undefined,
          minWidth: isNarrow ? "auto" : undefined,
          fontSize: isNarrow ? "0.8rem" : undefined,
        }}
      >
        Voltar
      </Button>
    </Box>
  );
};
